import React from 'react';
import ExecutiveSummaryBar from '../components/ExecutiveSummaryBar';
import RevenueCollectionPanel from '../components/RevenueCollectionPanel';
import NetworkServiceHealthPanel from '../components/NetworkServiceHealthPanel';
import SlaOperationalRiskPanel from '../components/SlaOperationalRiskPanel';
import ActivationPipelinePanel from '../components/ActivationPipelinePanel';
import AreaRiskTable from '../components/AreaRiskTable';
import StrategicRecommendationsPanel from '../components/StrategicRecommendationsPanel';
import QuickDrilldownLinks from '../components/QuickDrilldownLinks';
import CommandCenterFilterBar from '../components/CommandCenterFilterBar';
import { useExecutiveCommandCenterData } from '../hooks/useExecutiveCommandCenterData';

const ExecutiveCommandCenterPage = () => {
  const {
    timeframe,
    setTimeframe,
    areaFilter,
    setAreaFilter,
    dashboard,
    recommendations,
    filteredAreaRisk,
    isLoading,
    error,
    refetch,
  } = useExecutiveCommandCenterData();

  const areaOptions = (dashboard?.area_risk || []).map((row) => row.area_name).filter(Boolean);

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <div className="mx-auto w-full max-w-[1600px] space-y-4 p-4 lg:p-6">
        <header className="rounded-2xl border border-slate-800 bg-slate-900/70 p-4">
          <div className="text-xs uppercase tracking-[0.18em] text-slate-400">Executive / Owner Command Center</div>
          <h1 className="mt-1 text-2xl font-semibold">Strategic ISP Command Center</h1>
          <p className="mt-1 text-sm text-slate-400">
            Ringkasan kesehatan bisnis, jaringan, SLA, dan pipeline aktivasi untuk owner, investor, dan manajemen.
          </p>
        </header>

        <CommandCenterFilterBar
          timeframe={timeframe}
          onChangeTimeframe={setTimeframe}
          areaFilter={areaFilter}
          onChangeArea={setAreaFilter}
          areaOptions={areaOptions}
          onRefresh={refetch}
        />

        {isLoading ? (
          <div className="rounded-xl border border-slate-800 bg-slate-900/70 p-6 text-sm text-slate-400">Memuat command center...</div>
        ) : null}

        {error ? (
          <div className="rounded-xl border border-red-500/40 bg-red-500/10 p-4 text-sm text-red-200">
            {error?.message || 'Gagal memuat command center'}
          </div>
        ) : null}

        {!isLoading && !error ? (
          <>
            <ExecutiveSummaryBar summary={dashboard?.executive_summary} />
            <RevenueCollectionPanel data={dashboard?.revenue_collection_health} />
            <NetworkServiceHealthPanel data={dashboard?.network_service_health} />
            <SlaOperationalRiskPanel data={dashboard?.sla_operational_risk} />
            <ActivationPipelinePanel data={dashboard?.activation_pipeline} />
            <AreaRiskTable rows={filteredAreaRisk} />
            <StrategicRecommendationsPanel items={recommendations} />
            <QuickDrilldownLinks />
          </>
        ) : null}
      </div>
    </div>
  );
};

export default ExecutiveCommandCenterPage;
